import axios from 'axios';
import { USER_GLOBAL_HOST_API_KEY } from '../../config-global';

const getPartnerDetailsFromDomain = async (domain) => {
  try {
    const response = await axios({
      method: 'get',
      url: `${USER_GLOBAL_HOST_API_KEY}/no-auth/upp/partner/assets-metadata`,
      params: {
        domain,
      },
      withCredentials: true,
    });
    const res = await response.data;
    return res;
  } catch (error) {
    throw new Error(JSON.stringify(error));
  }
};

export { getPartnerDetailsFromDomain };
